var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getTime)?_c('base-icon-text',{attrs:{"icon":_vm.$t(_vm.icon)}},[_vm._t("default",[_vm._v(_vm._s(_vm.getTime))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }